module.exports = __webpack_public_path__ + "static/img/fucerep.18b805a9.svg";